import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'PaginationFilter',
    pure: false,
    standalone: false
})
export class PaginationFilterPipe implements PipeTransform {
    transform(items: any[], numberOfItems: number, offset: number): any {
        if(!items)
            return items;

        return items.slice(offset*numberOfItems, (offset+1)*numberOfItems);
    }
}
